import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import {
  type PacketDetail,
  deviceViewPacketDetailsEntityId,
  isPacketDetailsEntity,
} from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

export interface ShowPathLookupEdgeDetailCommand {
  detail: PacketDetail;
}

export const showPathLookupEdgeDetail: DeviceViewCommandFactory<
  ShowPathLookupEdgeDetailCommand
> = (cmdContext) => (command) => {
  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: TBD eventually cleanup
  cmdContext.updateState((draft) => {
    if (
      !draft.deviceViewWindows.some(
        (win) => win.id === deviceViewPacketDetailsEntityId,
      )
    ) {
      draft.deviceViewOpen = true;
    }
    draft.activeDeviceViewEntityId = deviceViewPacketDetailsEntityId;
    if (
      !draft.deviceViewEntities.some(
        (entity) => entity.id === deviceViewPacketDetailsEntityId,
      )
    ) {
      draft.deviceViewEntities.unshift({
        id: deviceViewPacketDetailsEntityId,
        deviceViewElement: 'packetDetails',
        details: [],
      });
    }
    const foundPacketDetailsEntity = draft.deviceViewEntities.find(
      (entity) => entity.id === deviceViewPacketDetailsEntityId,
    );
    if (
      foundPacketDetailsEntity !== undefined &&
      isPacketDetailsEntity(foundPacketDetailsEntity)
    ) {
      const foundDetail = foundPacketDetailsEntity.details.find(
        (detail) => detail.id === command.detail.id,
      );
      if (foundDetail === undefined) {
        foundPacketDetailsEntity.details.unshift(command.detail);
      } else {
        foundDetail.showAnimation = true;
      }
    } else {
      stumble('Tab must contain Path-Lookup data.');
    }
  });
};
